<template>
  <div
    :id="pillarId + '_' + indicatorId"
    class="bullet-container"
    :class="pillarId + '_' + indicatorId"
    style="width: 100%"
  />
</template>

<script>
import { mapGetters } from "vuex";
import { bullet } from "@/utils/BulletChart";
// import * as d3 from 'd3'

export default {
  name: "TemplateIndicatorBulletConsolidated",
  props: {
    pillarId: {
      type: String,
      default: "PP",
    },
    indicatorId: {
      type: String,
      default: "PP1",
    },
  },
  data: function () {
    return {
      indicator: {},
    };
  },
  computed: mapGetters(["getIndicatorDataConsolidated"]),
  watch: {
    pillarId: function () {
      this.indicator = this.getIndicatorDataConsolidated(
        this.pillarId,
        this.indicatorId
      );
      this.createBars();
    },
  },
  mounted() {
    this.indicator = this.getIndicatorDataConsolidated(
      this.pillarId,
      this.indicatorId
    );
    this.createBars();
  },
  updated() {
    this.createBars();
  },
  methods: {
    createBars() {
      var containerName = "." + this.pillarId + "_" + this.indicatorId;
      var element = this.$d3.select(containerName).node();
      var margin = { top: 5, right: 15, bottom: 15, left: 15 };
      var width =
        element.getBoundingClientRect().width - margin.left - margin.right;
      var height = 25;
      var chart = bullet().width(width).height(height).duration(2000);
      var svg = this.$d3.select("#" + this.pillarId + "_" + this.indicatorId);
      svg.selectAll("svg").remove();
      svg = this.$d3
        .select(containerName)
        .selectAll("svg")
        .data([this.indicator])
        .enter()
        .append("svg")
        .attr("class", "bullet")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
        .call(chart);

      svg.on("click", this.goToIndicator);
    },
    goToIndicator(indicator) {
      this.$router.push(
        "/reports/consolidated/" + this.pillarId + "/" + indicator.id
      );
    },
  },
};
</script>

<style lang="sass" scoped>
h3
  font-size: 1.5rem
  margin-top: 40px
.bullet-container
  margin-bottom: 15px
</style>
